export default {
  'common.save': 'सहेजें',
  'common.cancel': 'रद्द करें',
  'common.delete': 'हटाएँ',
  'common.edit': 'संपादित करें',
  'common.confirm': 'पुष्टि करें',
  'common.close': 'बंद करें',
  'common.search': 'खोजें',
  'common.loading': 'लोड हो रहा है...',
  'common.processing': 'प्रोसेस हो रहा है...',
  'common.submit': 'सबमिट करें',
  'common.back': 'वापस',
  'common.next': 'आगे',
  'common.previous': 'पिछला',
  'common.upload': 'अपलोड करें',
  'common.download': 'डाउनलोड करें',
  'common.downloadAll': 'सभी डाउनलोड करें',
  'common.refresh': 'रीफ़्रेश करें',
  'common.retry': 'पुनः प्रयास करें',
  'common.copy': 'कॉपी करें',
  'common.copied': 'कॉपी हो गया',
  'common.selectAll': 'सभी चुनें',
  'common.clear': 'साफ़ करें',
  'common.clearAll': 'सभी साफ़ करें',
  'common.apply': 'लागू करें',
  'common.reset': 'रीसेट करें',
  'common.filter': 'फ़िल्टर',
  'common.sort': 'क्रमबद्ध करें',
  'common.export': 'एक्सपोर्ट करें',
  'common.import': 'इंपोर्ट करें',
  'common.preview': 'पूर्वावलोकन',
  'common.view': 'देखें',
  'common.add': 'जोड़ें',
  'common.remove': 'हटाएँ',
  'common.rename': 'नाम बदलें',
  'common.share': 'साझा करें',
  'common.settings': 'सेटिंग्स',
  'common.logout': 'लॉग आउट',
  'common.profile': 'प्रोफ़ाइल',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.ok': 'ठीक है',
  'common.areYouSure': 'क्या आप निश्चित हैं?',
  'common.actionCannotBeUndone': 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
  'common.noData': 'कोई डेटा नहीं',
  'common.noResultsFound': 'कोई परिणाम नहीं मिला',
  'common.somethingWentWrong': 'कुछ गलत हो गया',
  'common.pleaseTryAgain': 'कृपया पुनः प्रयास करें',
  'common.success': 'सफल',
  'common.error': 'त्रुटि',
  'common.warning': 'चेतावनी',
  'common.info': 'जानकारी',
  'common.optional': 'वैकल्पिक',
  'common.required': 'आवश्यक',
  'common.name': 'नाम',
  'common.title': 'शीर्षक',
  'common.description': 'विवरण',
  'common.status': 'स्थिति',
  'common.actions': 'कार्रवाइयाँ',
  'common.date': 'दिनांक',
  'common.time': 'समय',
  'common.createdAt': 'बनाया गया',
  'common.updatedAt': 'अपडेट किया गया',
  'common.type': 'प्रकार',
  'common.size': 'आकार',
  'common.file': 'फ़ाइल',
  'common.folder': 'फ़ोल्डर',
  'common.files': 'फ़ाइलें',
  'common.folders': 'फ़ोल्डर',
  'common.all': 'सभी',
  'common.none': 'कोई नहीं',
  'common.send': 'भेजें',
  'common.sending': 'भेजा जा रहा है...',
  'common.new': 'नया',
  'common.create': 'बनाएँ',
  'common.duplicate': 'डुप्लिकेट करें',
  'common.move': 'स्थानांतरित करें',
  'common.moveTo': 'यहाँ ले जाएँ',
  'common.selectFile': 'फ़ाइल चुनें',
  'common.chooseFile': 'फ़ाइल चुनें',
  'common.dragDropFilesHere': 'फ़ाइलें यहाँ खींचकर छोड़ें',
  'common.or': 'या',
  'common.browse': 'ब्राउज़ करें',
  'common.continue': 'जारी रखें',
  'common.skip': 'छोड़ें',
  'common.done': 'हो गया',
  'common.finish': 'समाप्त करें',
  'common.start': 'प्रारंभ करें',
  'common.stop': 'रोकें',
  'common.pause': 'रोकें',
  'common.resume': 'फिर से शुरू करें',
  'common.enabled': 'सक्षम',
  'common.disabled': 'अक्षम',
  'common.active': 'सक्रिय',
  'common.inactive': 'निष्क्रिय',
  'common.draft': 'ड्राफ़्ट',
  'common.published': 'प्रकाशित',
  'common.archive': 'संग्रहित करें',
  'common.unarchive': 'संग्रह से निकालें',
  'common.favourite': 'पसंदीदा',
  'common.favourites': 'पसंदीदा',
  'common.pin': 'पिन करें',
  'common.unpin': 'अनपिन करें',
  'common.expand': 'विस्तृत करें',
  'common.collapse': 'संक्षिप्त करें',
  'common.showMore': 'और दिखाएँ',
  'common.showLess': 'कम दिखाएँ',
  'common.language': 'भाषा',
  'common.darkMode': 'डार्क मोड',
  'common.lightMode': 'लाइट मोड',
  'common.help': 'सहायता',
  'common.feedback': 'फ़ीडबैक',
  'common.notifications': 'सूचनाएँ',
  'common.rows': 'पंक्तियाँ',
  'common.column': 'कॉलम',
  'common.total': 'कुल',
  'common.page': 'पृष्ठ',
  'common.of': '/',
  'common.notes': 'नोट्स',
};
